import React, { useEffect } from 'react';

import '../shared.css';
import { size } from 'lodash';
import { CustomTooltipSmall } from '../CustomTooltip';

export const MyCustomProgressBarSmall = (props) => {
  const [color, setColor] = React.useState(props.defaultColor);
  const [pourcentage, setPourcentage] = React.useState(0);


  useEffect(() => {
    setPourcentage(props.maxValue === 0 ? 0 : (props.value * 100) / props.maxValue);
  }, [props]);

  return (
    <div style={{ margin: "5px" }}>
      <CustomTooltipSmall
        title={
          <span>
            <p>{props.label}</p>
          </span>
        }
        placement="top"
      >
        <span>
          <div style={{ color: color }} className={`text-progress text-${color}`}>
          </div>
          <div style={{ color: color }} className={`text-progress text-${color}`}>
            {props.value}/{props.maxValue}
          </div>
          <div className="progress progress-custom">
            <div
              className={`progress-bar`}
              role="progressbar"
              style={{ width: pourcentage, backgroundColor: color }}
              aria-valuenow="25"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </span>
      </CustomTooltipSmall>
    </div>
  );
};
